import React from "react";
import { Table } from "antd";

const DataTable = ({
  className = "",
  rowKey = "id",
  scrollX = 1100,
  rowClassName,
  pagination = false,
  ...props
}) => {
  const stripedRows = rowClassName || ((_, index) => (index % 2 === 1 ? "odd-row" : ""));
  const normalizedDataSource = Array.isArray(props.dataSource)
    ? props.dataSource
    : Array.isArray(props.dataSource?.data)
      ? props.dataSource.data
      : [];

  return (
    <Table
      {...props}
      className={`sapa-data-table ${className}`.trim()}
      dataSource={normalizedDataSource}
      pagination={pagination}
      rowClassName={stripedRows}
      rowKey={rowKey}
      scroll={{ x: scrollX, ...(props.scroll || {}) }}
      tableLayout="auto"
    />
  );
};

export default DataTable;
